// npm
import React, { memo } from 'react'
import { Box, Container, useMediaQuery, useTheme } from '@mui/material'
import SVG from 'react-inlinesvg'

// components
import ContentSectionBgImageWrapper, {
  ContentSectionBgImageWrapperProps,
} from './ContentSectionBgImageWrapper'
import SectionText, { SectionTextProps } from '@molecules/text/SectionText'
import { createImageSectionTextDefaults } from 'helpers/createImageSectionTextDefaults'

export interface ContentSectionBgImageProps
  extends ContentSectionBgImageWrapperProps {
  keyId: string
  mainHeading: string
  subtitle: string
  text: string
  button?: Queries.DatoCmsButton
  iconUrl?: string
  motif?: boolean
  forceHeadingBorder?: boolean
}

const ContentSectionBgImage = ({
  keyId,
  imageLandscape,
  imagePortrait,
  subtitle,
  mainHeading,
  text,
  button,
  iconUrl,
  hero,
  motif,
  forceHeadingBorder,
  isFirstSection,
}: ContentSectionBgImageProps) => {
  const theme = useTheme()
  const mdDown = useMediaQuery(theme.breakpoints.down('md'))
  const sectionTextVariant = 'centered'

  let sectionTextProps: SectionTextProps = createImageSectionTextDefaults({
    sectionTextVariant,
    keyId,
    mainHeading,
    subtitle,
    text,
    button,
  })
  sectionTextProps.subtitleProps.color = 'white'
  // @ts-ignore
  sectionTextProps.subtitleProps.borderType =
    hero || forceHeadingBorder ? 'bottom' : null
  // @ts-ignore
  sectionTextProps.buttonLinkProps.colorVariant = 'white-text'
  // @ts-ignore
  sectionTextProps.mainHeadingProps.typographyProps.variant = hero ? 'h1' : 'h2'
  sectionTextProps.textBoxProps = { mt: 4 }

  if (hero) {
    // @ts-ignore
    sectionTextProps.textBoxProps = { typography: 'heroText' }
  }

  return (
    <ContentSectionBgImageWrapper
      imageLandscape={imageLandscape}
      imagePortrait={imagePortrait}
      isFirstSection={isFirstSection}
      hero={hero}
    >
      <Container
        maxWidth={false}
        className={hero ? 'fixed-height' : ''}
        sx={{ height: '100%', position: 'relative' }}
      >
        <Box
          className={hero ? 'fixed-height' : ''}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: 1,
            height: 1,
            py: 10,
          }}
        >
          {iconUrl && (
            <Box mb={3} sx={{ svg: { width: '100px', height: 'auto' } }}>
              <SVG src={iconUrl} />
            </Box>
          )}
          <SectionText {...sectionTextProps} motif={motif} />
        </Box>
      </Container>
    </ContentSectionBgImageWrapper>
  )
}

export default memo(ContentSectionBgImage)
